/**
 * shadcn/ui (Radix) Message, adapted to Admin tokens and semantic articles.
 * https://ui.shadcn.com/docs/components/radix/message
 * Keep only the layout slots used by transcript inspection; replay owns timing.
 */
import type { ComponentProps } from 'react'
import { cn } from './cn'

export function Message({ className, align = 'start', ...props }: ComponentProps<'article'> & { align?: 'start' | 'end' }): JSX.Element {
  return <article data-slot="message" data-align={align} className={cn('group/message relative flex w-full min-w-0 gap-2 text-body text-text-primary data-[align=end]:flex-row-reverse', className)} {...props} />
}

export function MessageContent({ className, ...props }: ComponentProps<'div'>): JSX.Element {
  return <div data-slot="message-content" className={cn('flex w-fit min-w-0 max-w-[90%] flex-col gap-2 break-words group-data-[align=end]/message:items-end', className)} {...props} />
}

export function MessageHeader({ className, ...props }: ComponentProps<'div'>): JSX.Element {
  return <div data-slot="message-header" className={cn('flex max-w-full min-w-0 items-center px-3 text-caption font-medium text-text-secondary', className)} {...props} />
}

export function MessageFooter({ className, ...props }: ComponentProps<'div'>): JSX.Element {
  return <div data-slot="message-footer" className={cn('flex max-w-full min-w-0 items-center px-3 text-caption text-text-secondary group-data-[align=end]/message:justify-end', className)} {...props} />
}
